import { mapGetters, mapMutations } from 'vuex';
import { VIDEO_TYPE } from '@/helpers';

import Login from '@/components/popups/Login/index.vue';
import Registration from '@/components/popups/Registration/index.vue';
import Reset from '@/components/popups/Reset/index.vue';
import Restore from '@/components/popups/Restore/index.vue';
import addressesList from '@/components/popups/addresses-list/index.vue';
import SuccessRegister from '@/components/popups/SuccessRegister/index.vue';
import anotherCosmetolog from '@/components/popups/activate-another-cosmetolog/index.vue';
import fastBuy from '@/components/popups/fast-buy/index.vue';
import defaultPrices from '@/components/popups/default-prices/index.vue';
import formApplication from '@/components/popups/form-application/index.vue';
import PaymentInfo from '@/components/popups/PaymentInfo/index.vue';
import successRegisterAgent from '@/components/popups/successRegisterAgent/index.vue';
import seminarRegistration from '@/components/popups/seminar-registration/index.vue';
import successRegisterSeminar from '@/components/popups/succes-seminar-register/index.vue';
import SuccessOrder from '@/components/popups/SuccessOrder/index.vue';
import Basket from '@/components/popups/Basket/index.vue';
import seminarDetails from '@/components/popups/seminar-details/index.vue';
import seminarInfo from '@/components/popups/seminar-info/index.vue';
import notifyWhenAvailable from '@/components/popups/notify-when-available/index.vue';
import SMSModal from '@/components/popups/SMSModal/index.vue';
import remainings from '@/components/popups/remainings/index.vue';
import metodistPopup from '@/components/popups/metodist-popup/index.vue';
import createManagerPopup from '@/components/popups/create-manager-popup/index.vue';
import videoModal from '@/components/popups/video-modal/index.vue';
import YoutubeModal from '@/components/popups/YoutubeModal/index.vue';
import MessengerModal from '@/components/popups/MessengerModal/index.vue';
import ReviewModal from '@/components/popups/ReviewModal/index.vue';
import LangModal from '@/components/popups/LangModal/index.vue';
import RedirectLangModal from '@/components/popups/RedirectLangModal/index.vue';
import FirstOrderPromo from '@/components/popups/FirstOrderPromo/index.vue';
import ReviewCreateModal from '@/components/popups/ReviewCreateModal/index.vue';
import ZoomModal from '@/components/popups/ZoomModal/index.vue';
import ProfileOrderPromo from '@/components/popups/ProfileOrderPromo/index.vue';

export default {
  name: 'Hidden',
  components: {
    ReviewCreateModal,
    FirstOrderPromo,
    RedirectLangModal,
    LangModal,
    ReviewModal,
    Login,
    Registration,
    Reset,
    Restore,
    addressesList,
    SuccessRegister,
    anotherCosmetolog,
    fastBuy,
    defaultPrices,
    formApplication,
    PaymentInfo,
    successRegisterAgent,
    seminarRegistration,
    successRegisterSeminar,
    SuccessOrder,
    Basket,
    seminarDetails,
    notifyWhenAvailable,
    SMSModal,
    remainings,
    seminarInfo,
    metodistPopup,
    createManagerPopup,
    videoModal,
    YoutubeModal,
    MessengerModal,
    ZoomModal,
    ProfileOrderPromo
  },
  data() {
    return {
      VIDEO_TYPE
    };
  },
  computed: {
    ...mapGetters({
      loginPopup: 'popups/loginPopup',
      addressesListPopup: 'popups/addressesListPopup',
      anotherCosmetolog: 'popups/anotherCosmetolog',
      fastBuyPopup: 'popups/fastBuyPopup',
      showDefaultPrice: 'popups/showDefaultPrice',
      formApplicationPopup: 'popups/formApplicationPopup',
      paymentInfoPopup: 'popups/paymentInfoPopup',
      isRegisterAgent: 'popups/successRegisterAgent',
      showSeminarRegistration: 'seminars/showSeminarPopup',
      isShowSeminarSuccess: 'seminars/showSuccessPopup',
      isShowRemaingsPopup: 'popups/showRemainingsPopup',
      showSuccessPaymentPopup: 'popups/showSuccessPaymentPopup',
      showSeminarInfoPopup: 'popups/showSeminarInfoPopup',
      seminarDetails: 'popups/seminarDetails',
      shoeNotifyWhenAvailable: 'popups/shoeNotifyWhenAvailable',
      isProfessional: 'profile/isProfessional',
      metodistPopup: 'metodist/popupOpen',
      showManagerPopup: 'managers/showManagerPopup',
      seminarVideoModalStatus: 'popups/seminarVideoModalStatus',
      seminarVideoModalUrl: 'popups/seminarVideoModalUrl',
      modal: 'app/modal',
      modalData: 'app/modalData'
    })
  },
  methods: {
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      changeAddressesListPopup: 'popups/CHANGE_ADDRESSES_LIST_POPUP',
      changeAnotherCosmetologPopup: `popups/CHANGE_COSMETOLOG_POPUP`,
      changeFastBuyPopup: `popups/CHANGE_FAST_BUY_POPUP`,
      changeDefaultPricesPopup: `popups/CHANGE_DEFAULT_PRICES`,
      changeApplicationFormPopup: `popups/CHANGE_APPLICATION_FORM_POPUP`,
      changePaymentInfoPopup: 'popups/CHANGE_PAYMENT_INFO_POPUP',
      changeRegisterAgent: 'popups/CHANGE_SHOW_SUCCESS_AGENT_REGISTER',
      showRemainingsPopup: 'popups/CHANGE_REMAININGS_POPUP',
      changeSeminarRegistration: 'seminars/SHOW_SEMINAR_POPUP',
      changeSeminarSuccess: 'seminars/SHOW_SUCCESS_SEMINAR',
      changeSuccessPayment: 'popups/SHOW_SUCCESS_PAYMENT_POPUP',
      changeSeminarDetails: 'popups/SHOW_SEMINAR_DETAILS_POPUP',
      changeSeminarInfo: 'popups/SHOW_SEMINAR_INFO_POPUP',
      showNotifyPopup: 'popups/SHOW_NOTIFY_WHEN_AVAILABLE',
      closeMetodistPopup: 'metodist/CLOSE_METODIST_POPUP',
      showManagerCreatePopup: 'managers/SHOW_MANAGER_CREATE_POPUP',
      showSeminarVideoModal: 'popups/SHOW_SEMINAR_VIDEO_MODAL',
      modalOpen: 'app/MODAL_OPEN',
      modalClose: 'app/MODAL_CLOSE'
    }),
    onCloseSuccessRegister() {
      this.modalClose('successRegister');
      setTimeout(() => {
        this.$router
          .push({ name: 'profile' })
          .then(() => {})
          .catch(() => {});
      }, 400);
    },
    onCloseLangModal() {
      this.modalClose('langModal');
    }
  }
};
